<template>
  <div :class="['nav', 'nav-bar', $props.from, aStyle]">
    <div class="nav-wrapper">
      <!-- <router-link class="logo" to="/"><img :src="logoSrc"></router-link>  -->
      <ul class="menulist clearfix">
        <li class="item clearfix nav_home">
          <router-link class="" :to="{name: 'Home'}"><span>首页</span></router-link>
        </li>
        <li class="item clearfix" @click="onScroll('fw')">
          <!-- <router-link class="" :to="{name: 'NewService', query: { anchor: 'fw' }}"><span>平台服务</span></router-link> -->
          <router-link class="" :to="{name: 'HelpPlatform'}"><span>平台服务</span></router-link>
        </li>
        <li class="item clearfix" @click="onScroll('zj')">
          <!-- <router-link class="" :to="{name: 'NewService', query: { anchor: 'zj' }}"><span>咨询专家</span></router-link> -->
          <router-link class="" :to="{name: 'RcepClassroom'}"><span>咨询专家</span></router-link>
        </li>
        <li class="item clearfix" @click="onScroll('hp')">
          <!-- <router-link class="" :to="{name: 'NewService', query: { anchor: 'hp' }}"><span>使用帮助</span></router-link> -->
          <router-link class="" :to="{name: 'HelpManual'}"><span>使用帮助</span></router-link>
        </li>
        <!-- <li class="item clearfix nav_home">
          <router-link class="linka" :to="{name: 'Home'}"><span>首页</span></router-link>
        </li>
        <li class="item coo_wrap clearfix">
          <router-link class="linka" :to="{name: 'News'}"><span>新闻</span></router-link>
        </li>
        <li class="item search clearfix" v-if="$i18n.locale === 'zh-CN'">
          <Dropdown @on-click="onOtherMenu">
            <a href="#" :class="['linka', ['queryRate', 'queryRules', 'queryHsCode', 'RulesDecide', 'InvoiceMaterialAdd', 'InvoiceMaterialEdit', 'InvoiceMaterialShow', 'RulesDecideVoteResult', 'EnjoyDiscount', 'EnjoyResult'].indexOf(this.$route.name) == -1? '' : 'router-link-active']" @click.prevent>
              <span>其他</span>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="rate">税率查询</DropdownItem>
              <DropdownItem name="hscode">税则查询</DropdownItem>
              <DropdownItem name="rules">原产地规则查询</DropdownItem>
              <DropdownItem name="rulesdecide">原产地判定查询</DropdownItem>
              <DropdownItem name="enjoy">享惠分析查询</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
        <li :class="['item', 'clearfix', $props.from == 'default'? 'tel default' : 'tel']">
          <Tooltip :theme="$props.from == 'home'? 'light' : 'dark'" content="400-099-9825">
            <img src="~@/assets/images/new_home/tel.png" v-if="$props.from == 'home'">
            <img src="~@/assets/images/new_home/tel2.png" v-else>
          </Tooltip>
        </li> -->
        <li class="item clearfix">
          <Account :class="['line4', $props.from !== 'home'? 'icon2' : 'icon3']">
            <span slot="name">
              <!-- <img src="~@/assets/images/new_home/person.png" v-if="$props.from == 'home'">
              <img src="~@/assets/images/new_home/person2.png" v-else> -->
              登录
            </span>
          </Account>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ATag from '../common/ATag'
import Account from '../layout/Account'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapAccountState } = createNamespacedHelpers('account')

export default {
  name: 'NavHome',
  props: {
    from: {
      type: String,
      default: 'default',
      required: false
    }
  },
  data () {
    let logoPath = this.$props.from === 'default' ? require('@/assets/images/logo_2.png') : require('@/assets/images/logo.png')
    let aStyle = this.$props.from === 'default' ? this.$style.aStyleBlank : this.$style.aStyle
    return {
      isScrolled: false,
      logoSrc: logoPath,
      aStyle: aStyle
    }
  },
  computed: {
    ...mapAccountState({
      userInfo: state => state.userInfo
    })
  },
  components: { ATag, Account },
  methods: {
    onScroll(name) {
      setTimeout(() => {
        let anchor = document.querySelector(`.${name}`)
        if(anchor) this.$scrollTo(anchor)
        this.isScrolled = true
      }, this.isScrolled ? 0 : 200)
    },
    onOtherMenu(name) {
      switch(name) {
        case 'rate':
          this.$router.push({
            name: 'queryRateI',
            params: { exporter: 1, importer: 1, hscode: 1}
          })
          break
        case 'hscode':
          this.$router.push({
            name: 'queryHsCode',
            params: { hscode: 1 }
          })
          break
        case 'rules':
          this.$router.push({
            name: 'queryRules',
            params: { exporter: 1, importer: 1, hscode: 1 }
          })
          break
        case 'rulesdecide':
          this.$router.push({ name: 'RulesDecide' })
          break
        case 'enjoy':
          this.$router.push({ name: 'EnjoyDiscount' })
          break
        default: this.$Message.info({content: '即将上线，敬请期待', duration: 1})
      }
    }
  },
}
</script>

<style scoped>
  .nav_home a{
    position: relative;
  }
  .nav_home .chris{
    width: 16px;
    position: absolute;
    top: 0;
    right: -8px;
  }
  .nav{
    padding-top: 0;
    width: 100%;
  }
  .nav.default{
    box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
    margin-bottom: 10px;
  }
  .nav.default {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .nav .nav-wrapper{
    margin: 0 auto;
    width:1400px;
    height: 60px;
    max-width: 1560px;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center
  }
  .logo{
    display: block;
    width: 68px;
    text-decoration: none !important;
    box-shadow: none !important;
  }
  .logo:after,
  .logo.router-link-exact-active:after,
  .logo.router-link-active:after{
    height: 0;
    width: 0;
    content: none;
  }
  .logo img{
    display: block;
    width: 100%;
    height: auto;
  }
  .logo span{
    display: block;
    white-space: nowrap;
    font-size: 12px;
    color: #fff;
    line-height: 15px;
    font-family: Arial;
    letter-spacing: 5px;
    margin-top: 9px;
  }
  .logo.default{
    top: -3px;
  }
  .logo.default span{
    color: #333;
    margin-top: 3px;
  }
  .nav ul.menulist{
    position: absolute;
    top:0;
    right: 0;
    height: 100%;
  }
  .nav.home .line4::after{
    margin-top: 18.3px;
    height: 2px;
  }
  .nav.default .line4::after{
    margin-top: 12px;
  }
  .nav.home ul.menulist li.search .line4::after{
    margin-top: 18.4px;
  }
  .nav ul.menulist li.item{
    float: left;
    padding-right: 60px;
    position: relative;
    display: block;
    height: 100%;
  }
  .nav ul.menulist li.item a{
    position: relative;
    transform: translateY(-50%);
    top: 50%;
    float: left;
    font-size: 1.5rem;
    padding: 0 12px;
  }
  .nav.default ul.menulist li.item{
    padding-right: 60px;
  }
  .nav.default ul.menulist li.item a{
    padding: 0 12px;
  }
  .nav ul.menulist li.item:last-child{
    padding-right: 0;
  }
  .nav li.search >>> .ivu-dropdown{
    top: 50%;
    display: block;
    position: relative;
    transform: translateY(-50%);
    min-height: 22px;
  }
  .nav li.search >>> .ivu-dropdown .ivu-select-dropdown{
    border-radius: 2px;
    /* border: 0.5px solid #d8d8d8; */
    border: 0 none;
    min-width: 142px;
    padding: 6px 0 12px;
  }
  .nav li.search >>> .ivu-dropdown .ivu-dropdown-rel a{
    float: none;
    position: static;
    transform: none;
  }
  .nav li.search >>> .ivu-dropdown .ivu-dropdown-item a{
    color: #333;
    display: block;
    float: none;
    position: static;
    transform: none;
    text-decoration: none;
    box-shadow: none;
    text-align: center;
  }
  .nav li.search >>> .ivu-dropdown .ivu-dropdown-item a:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .nav li.search >>> .ivu-dropdown .ivu-dropdown-item a:after{
    content:none;
  }
  .coo_wrap a{
    position: relative;
  }
  .coo_wrap a img{
    width: 32px;
    position: absolute;
    top: -2px;
    right: -32px;
  }
  .nav.default ul.menulist li.tel{
    padding-right: 60px !important;
  }
  .nav.home ul.menulist li.tel{
    padding-right: 70px !important;
  }
  .tel img{
    height: 20px;
  }
  .tel >>> .ivu-tooltip{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 4px;
  }
  .icon2 img,
  .icon3 img{
    height: 20px;
  }
  .tel{
    color: #fff;
    font-size: 14px;
  }
  .tel.default{
    color: #333;
  }
  /* .tel span{
    position: relative;
    transform: translateY(-50%);
    top: 50%;
    float: left;
    display: flex;
    align-items: center;
  } */
  .tel .svg-icon{
    font-size: 22px;
    padding-right: 6px;
  }
  .linka{
    border: 1px solid #fff;
    height: 26px;
    display: block;
    position: relative;
  }
  /* .nav.home .linka.router-link-active, */
  .nav.home .linka:hover{
    background-color: #fff;
    color: #2b7fbb;
    font-weight: bold;
  }
  .nav.default .linka{
    color: #666;
    border: 0 none;
  }
  /* .nav.default .linka.router-link-active::after, */
  .nav.default .linka:hover::after{
    content: '';
    position: absolute;
    height: 2px;
    background-color: #666;
    top: 100%;
    margin-top: 3px;
    left: 13px;
    right: 13px;
    width: inherit;
  }
  .nav.default .nav_home .linka.router-link-active::after{
    display: none;
  }
  .nav.default .nav_home .linka.router-link-active:hover:after{
    display: block;
  }
  .item >>> .ivu-dropdown .ivu-dropdown-item{
    font-size: 16px !important;
  }
</style>
<style module>
  /*白色主题*/
  .aStyle a{
    color: #fff;
  }
  .aStyle a:hover{
    color: #fff;
  }
  .aStyle a:after{
    background-color: #fff;
  }
  .aStyle {
    border-bottom: 0.5px solid #4c71b3;
  }
  /*蓝色主题*/
  .aStyleBlank a{
    color: #333;
  }
  .aStyleBlank a:hover{
    color: #333;
  }
  .aStyleBlank a:after{
    background-color: #333;
  }
  .aStyleBlank a[class~="router-link-exact-active"],
  .aStyleBlank a[class~="router-link-active"]{
    /* color: #1F8AFD; */
  }
  .aStyle a[class~="line4"]:after,
  .aStyleBlank a[class~="line4"]:after{
    margin-top: 2px;
    height: 2px;
    background: linear-gradient(0deg, #333 100%, transparent 100%);
  }
  .aStyle a[class~="line4"]:after{
    background: linear-gradient(0deg, #ddaa1d 100%, transparent 100%);
  }
  .aStyleBlank a[class~="router-link-exact-active"]:after,
  .aStyleBlank a[class~="router-link-active"]:after{
    background: inherit;
    background-color: #1F8AFD;
  }
  .aStyleBlank a[class~="link1"]:after{
    background-color: #1F8AFD;
    background: linear-gradient(0deg, #1F8AFD 100%, transparent 100%);
  }
  .aStyle a[class~="line4"]:hover:after,
  .aStyleBlank a[class~="line4"]:hover:after{
    width: 100%;
    left: 0;
    right: 0%;
  }
  .aStyle a[class~="router-link-exact-active"]:after,
  .aStyleBlank a[class~="router-link-exact-active"]:after,
  .aStyle a[class~="router-link-active"]:after,
  .aStyleBlank a[class~="router-link-active"]:after{
    width: 100%;
    left: 0;
    right: 0%;
  }
</style>





// WEBPACK FOOTER //
// src/components/layout/NavHome.vue